import { render, staticRenderFns } from "./KeyBox.vue?vue&type=template&id=16c78ee2&scoped=true&"
import script from "./KeyBox.vue?vue&type=script&lang=js&"
export * from "./KeyBox.vue?vue&type=script&lang=js&"
import style0 from "./KeyBox.vue?vue&type=style&index=0&id=16c78ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c78ee2",
  null
  
)

export default component.exports